import useMediaQueries from "hooks/useMediaQueries.js";
import SubUserMobileTable from "./SubUserMobileTable.js";
import "./SubUserMobileTable.scss";
import "./SubUserMobileTable.scss";
import SubUserTableContainerDesktop from "./SubUserTableContainerDesktop.js";
import "./SubUserTable.scss";
import "./SubUserTable.scss";
import Pagination from "components/Reusable/Pagination/Pagination.js";

const SubUserTableContainer = ({
  currentPage,
  setCurrentPage,
  sizeNumber,
  setLoading,
  setSubUsers,
  setNumberOfUsers,
  numberOfUsers,
  fieldToOrder,
  orderAscending,
  subUsers,
  setFieldFilter,
  loading,
  withoutPagination,
}) => {
  const { mobileCondition } = useMediaQueries();

  return (
    <div className="table-container">
      {mobileCondition ? (
        <>
          <SubUserMobileTable
            currentPage={currentPage}
            sizeNumber={sizeNumber}
            setLoading={setLoading}
            setSubUsers={setSubUsers}
            setNumberOfUsers={setNumberOfUsers}
            fieldToOrder={fieldToOrder}
            orderAscending={orderAscending}
            tableData={subUsers}
            loading={loading}
          />
        </>
      ) : (
        <SubUserTableContainerDesktop
          currentPage={currentPage}
          sizeNumber={sizeNumber}
          setLoading={setLoading}
          setSubUsers={setSubUsers}
          setNumberOfUsers={setNumberOfUsers}
          fieldToOrder={fieldToOrder}
          orderAscending={orderAscending}
          subUsers={subUsers}
          loading={loading}
          setFieldFilter={setFieldFilter}
        />
      )}

      {!withoutPagination && Math.ceil(numberOfUsers / sizeNumber) > 1 && (
        <Pagination
          maxPages={
            numberOfUsers > 0 ? Math.ceil(numberOfUsers / sizeNumber) : 1
          }
          currentPage={currentPage + 1}
          setCurrentPage={setCurrentPage}
        />
      )}
    </div>
  );
};

export default SubUserTableContainer;
